import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

const AttemptCell = ({data, column, meet, match, style}) => {
  const lifter = data;
  if(lifter.row === 'header') {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else if(lifter.row === 'title') {
    return (
      <div style={style} className="table-cell-inner" />
    );
  } else {
    const attempt = _.get(lifter, ['lifts', column.lift, column.attemptNumber]);
    if(!attempt || !_.get(lifter, ['division', 'lifts', column.lift])) {
      return null;
    }

    let isCurrentAttempt = false;
    _.every(meet.platforms, (platform) => {
      isCurrentAttempt = _.get(meet, ['platforms', platform._id, 'currentAttemptId']) === _.get(attempt, '_id');

      if(isCurrentAttempt) {
        return false; //break loop
      }

      return true; // continue loop
    });

    return (
      <div style={style} className={classNames('table-cell-inner', attempt.result || '', {'current-attempt': isCurrentAttempt})}>
        {_.get(attempt, column.key)}
      </div>
    );
  }
};

export default AttemptCell;
